var _circle, _circle2, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoModalTelefonica(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 36,
    fill: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15622_161496",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 31,
    width: 34,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 31H63.9019V63.5411H30V31Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15622_161496)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7966 57.4963C36.5712 57.4963 30.7305 51.6149 30.7305 44.3294C30.7305 37.044 36.5712 31.1626 43.7966 31.1626C51.022 31.1626 56.8468 37.044 56.8468 44.3294C56.8468 51.6149 51.022 57.4963 43.7966 57.4963ZM43.8125 53.7522C49.3509 53.7522 51.8177 48.8224 51.8177 44.3294C51.8177 39.5401 48.8575 34.9067 43.8125 34.9067C38.7357 34.9067 35.7755 39.5401 35.7755 44.3294C35.7755 48.8224 38.2423 53.7522 43.8125 53.7522ZM56.3375 63.1281V61.2716C57.4038 60.2576 61.2552 57.1063 61.2552 55.0626C61.2552 54.033 60.3322 53.565 59.3932 53.565C58.4383 53.565 57.5312 53.9706 56.7832 54.4542L56.6081 52.5977C57.6266 52.0985 58.8203 51.8021 59.9661 51.8021C62.1306 51.8021 63.5311 52.8785 63.5311 55.0626C63.5311 57.4183 61.112 59.5868 59.25 61.3808H63.8971V63.1281H56.3375Z",
    fill: "#0066FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoModalTelefonica);
export default __webpack_public_path__ + "static/media/logoModalTelefonica.ba7d53210fe4f25b59ff472c8794ea2d.svg";
export { ForwardRef as ReactComponent };